import { fetchAuthSession } from 'aws-amplify/auth';

export class AuthTokenError extends Error {}

export async function getAuthToken(): Promise<string> {
  const session = await fetchAuthSession();
  const token = session.tokens?.accessToken?.toString();
  if (!token) throw new AuthTokenError('No Cognito token available');
  return token;
}
